require('core-js/stable')
require('regenerator-runtime/runtime')
const title = 'Deforestation Free Funds'
const description = 'Deforestation Free Funds grades mutual funds and ETFs on investments in companies and sectors driving deforestation.'
const domain =  process.env.DOMAIN || 'https://deforestationfreefunds.org'
// if were not the client (window) use the injected config otherwise create it
const Version = require('./data/Version.json')
const FootprintRanges = require('./data/FootprintRanges.json')
const TargetDateSeries = require('./data/TargetDateSeries.json')
const CoreBenchmarks = require('./data/CoreBenchmarks.json')
const ExtendedBenchmarks = require('./data/ExtendedBenchmarks.json')
const FamilyFunds = require('./data/FamilyFunds.json')
const FundCategoryAll = require('./data/FundCategoryAll.json')
const FundFamilyAll = require('./data/FundFamilyAll.json')
const FundFamilyPetitions = require('./data/FundFamilyPetitions.json')
const GefScoreNormalizersAllScored = require('./data/GefScoreNormalizersAllScored.json')
const GefScoreNormalizersGroups = require('./data/GefScoreNormalizersGroups.json')
const GefScoreNormalizersPeers = require('./data/GefScoreNormalizersPeers.json')
const Changelog = require('./data/Changelog.json')
const CompanySectors = require('./data/CompanySectors.json')
const CompanyLinks = require('./data/CompanyLinks.json')
const CompanyProfiles = require('./data/CompanyProfiles.json')

let config = {
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  version: Version['version'],
  domain: domain,
  loggingOff: process.env.LOGGING_OFF,
  httpsRedirect: process.env.HTTPS_REDIRECT,
  gaKey: process.env.GA_KEY,
  gtmId: process.env.GTM_ID,
  apiHost: process.env.APIHOST || 'https://api.fossilfreefunds.org',
  apiPort: process.env.APIPORT || 443,
  imageSocialShare: 'social-share-img.jpg',
  shareMessage: title,
  queryMaxFunds: 10,
  changelog: Changelog,
  companySectors: CompanySectors,
  companyLinks: CompanyLinks,
  companyProfiles: CompanyProfiles,
  gefScoreNormalizers: {
    overall: 22,
    balance: 15,
    policies: 7,
    allScored: GefScoreNormalizersAllScored['all_scored'],
    groups: GefScoreNormalizersGroups,
    peers: GefScoreNormalizersPeers,
  },
  signupForm: {
    url: 'https://go.asyousow.org/l/344561/2019-02-04/g15ptn',
    id: '344561_49031pi_344561_49031'
  },
  getStartedInput: {
    label: 'Top-scoring funds',
    title: 'Top-scoring funds | Deforestation Free Funds',
    faclass: null,
  },
  socialAppId: '1094061130685792',
  profilePath: 'profile',
  routes: {
    home: '/',
    speakOut: '/#companies',
    about: '/about',
    howitworks: '/how-it-works',
    works: '/how-it-works',
    list: '/funds',
    compare: '/compare',
    fund: '/fund',
    targetdate: '/target-date-funds',
    targetDateFunds: '/target-date-funds',
    clean: '/funds?dsc=false&srt=grade_deforestation',
    toolkit: '/toolkit',
    faq: '/faq',
    media: '/media',
    families: '/families',
    legal: '/legal',
    notFound: '/not-found-404',
    indexfunds: '/index-funds',
    companies: '/companies',
    petitions: '/petitions',
  },
  links: {
    changelog: 'https://iyv-charts.s3-us-west-2.amazonaws.com/files/',
    signup: 'https://go.asyousow.org/sign-up-deforestation-free-funds',
    socialAYSfb: 'https://www.facebook.com/asyousow.org/',
    socialAYStwitter: 'https://twitter.com/asyousow',
    socialAYSinstagram: 'https://www.instagram.com/_asyousow_/',
    contact: 'https://www.asyousow.org/contact/',
    donate: 'https://connect.clickandpledge.com/w/Form/9d5e83e2-b2d9-43eb-9834-043d7558b785',
    toolkit: 'http://webiva-downton.s3.amazonaws.com/877/a3/3/8741/Deforestation_Free_HowToGuide.pdf',
    speakout: 'https://earthhq.foe.org/defend-the-rainforest/link_jobs/10',
    earthhq: 'https://earthhq.foe.org/defend-the-rainforest',
    friends: 'http://www.foe.org/',
    foemain: 'http://www.foe.org/DeforestationFreeAction',
    foeabout: 'http://www.foe.org/about-us/friends-of-the-earth-international',
    foereport: 'http://webiva-downton.s3.amazonaws.com/877/72/7/8646/Invested_in_Exploitation.Digital.compressed.pdf',
    ays: 'http://www.asyousow.org',
    aysabout: 'http://www.asyousow.org/about-us',
    aysvote: 'https://www.asyousow.org/vote-your-shares',
    profundo: 'http://www.profundo.nl',
    ran: 'http://www.ran.org/sf20scorecard',
    uocs: 'http://www.ucsusa.org/global-warming/stop-deforestation/palm-oil-scorecard-2015#.V358U_krLGg',
    zoolondon: 'https://www.spott.org/',
    spott: 'https://www.spott.org/',
    forest500: 'https://forest500.org/',
    supplychange: 'https://supply-change.org/',
    cdpForests: 'https://www.cdp.net/en/forests',
    greenpeace: 'http://www.greenpeace.org/usa/palm-oil-scorecard-are-brands-doing-enough-for-indonesias-rainforests/',
    ceres: 'https://engagements.ceres.org/',
    fAndf: 'https://forestsandfinance.org/',
    fff: 'https://fossilfreefunds.org',
    dff: 'https://deforestationfreefunds.org',
    gef: 'https://genderequalityfunds.org',
    sjf: 'https://socialjusticefunds.org',
    wff: 'https://weaponfreefunds.org',
    gff: 'https://gunfreefunds.org',
    tff: 'https://tobaccofreefunds.org',
    pff: 'https://prisonfreefunds.org',
    iyv: 'https://investyourvalues.org',
    compareFeedback: 'https://forms.gle/cdJG5C7WoGxKkEx78',
    aysinvest: 'https://www.asyousow.org/invest-your-values/',
    fffFund: 'https://fossilfreefunds.org/funds',
    ussifperf: 'https://www.ussif.org/performance',
    ussif: 'https://www.ussif.org/',
    reader: 'https://get.adobe.com/reader/',
    socialFoefb: 'https://www.facebook.com/foe.us/',
    socialFoetwitter: 'https://twitter.com/foe_us',
    stakedff: 'https://www.yourstake.org/petition/deforestation-free-funds/',
    whitePaper: 'https://www.asyousow.org/ays_report/aligning-defined-contribution-plans-with-corporate-sustainability-goals/',
    slides401k: 'https://fossilfreefunds.org/file/Sustainable-Fossil-Free-401ks-FossilFreeFunds-AsYouSow-HIPinvestor.pdf',
    // socialFoeinstagram: 'https://www.instagram.com/codepinkalert/',
  },
  // footprint date IF NEEDED
  footprintDate: 'Jun. 2020',
  // for footprint scoring
  footprintRanges: FootprintRanges, 
  coreBenchmarks: CoreBenchmarks,
  extendedBenchmarks: ExtendedBenchmarks,
  // asset managers for Family view
  familyFunds: FamilyFunds,
  // target dates
  targetDateSeries: TargetDateSeries,
  fundFamilyPetitions: FundFamilyPetitions,
  engagementFunds: [
    {
      name: 'Green Century',
      statement: 'Addressing deforestation is one of the most cost effective ways to mitigate climate change, while also helping to promote human rights and conserve the habitats of endangered species. That’s why Green Century launched an investor campaign to stop deforestation caused by major agricultural commodity growers and purchasers. By pressing highly recognizable household brand names like Kellogg’s and Starbucks to adopt sustainable palm oil purchasing policies, Green Century helped build the momentum to transform the rest of the supply chain and created significant environmental impact. For example, the commitment to zero-deforestation by Wilmar, the largest supplier of palm oil in the world, is expected to prevent 1.5 gigatons of carbon pollution between now and 2020. Through shareholder proposals, policy work, and assisting the implementation process, Green Century has helped companies protect their bottom line, their shareholder’s investments, and the environment from the risks of deforestation.',
      filedAt: 'Aramark, Bunge, Chevron Corporation, ConAgra Foods, EOG Resources, Inc., EQT Corporation, Exxon Mobil Corporation, FirstEnergy Corp., International Business Machines Corp., Kellogg Company, Kraft Heinz, Kroger, McDonald\'s, Noble Energy, Inc., Southern Company, Starbucks, Target, Time Warner Inc., Tyson Foods, Ultra Petroleum Corp., Verizon Communications Inc., Vertex Pharmaceuticals Incorporated, Western Union Co., WPX Energy, Inc., and Xcel Energy Inc.'
    },
    {
      name: 'Boston Common',
      statement: 'For the last 10 years, Boston Common has made responsible sourcing including sustainable palm oil, an engagement priority including both the environmental risks such as deforestation and water scarcity and the social risks such as labor practices and land rights. We have also engaged natural resource companies regarding their operations in the Amazon including helping advance the rights of Indigenous Peoples to protect their forests globally. Our engagements include leading a long-term dialogue with Golden Agri-Resources (GAR), the second largest palm oil producer. We focused on GAR’s commitment to end deforestation in supply chain, investments in traceability of certified sustainable palm oil (CSPO) in the value chain, transparency in landownership issues by collaborating with authorities and company efforts to improve yielding practices for smallholders. Other engagements have included financing and adopting sector-specific guidance by bank lenders including HSBC Holdings and responsible sourcing of food commodities with Olam, PepsiCo, Mondelez, Tesco and Unilever. One outcome was that HSBC adopted a standard of RSPO membership for any palm oil producers they finance.',
      filedAt: 'Gilead Sciences, Home Depot, JPMorgan Chase, and PNC Financial Services Group.'
    },
    {
      name: 'Trillium Asset Management',
      statement: 'Trillium Asset Management engages companies on their environmental, social, and governance (ESG) performance through various tools such as direct dialogue with senior company leadership, filing or co-filing shareholder proposals, convening company meetings, investor education, and speaking publicly about the issue of concern. We use shareholder advocacy as a way to have a positive impact on company policies, practices, and performance. Alongside As You Sow and other entities, we’ve successfully engaged with companies to phase out sales of old-growth wood and give preference to the purchase of wood and wood products originating from certified well-managed forests. Additionally, we’ve successfully encouraged many companies to strengthen palm oil policies, manage commodities such as beef, soy, pulp, and paper in its global supply chain, and support protections for forests. Please visit trilliuminvest.com for further information.',
      filedAt: '3M Co., Akamai Technologies, Inc., Amgen Inc., Anadarko Petroleum Corporation, AT&T, Inc., Bank of America Corporation, Chipotle Mexican Grill, Inc., Church & Dwight Co. Inc., ConocoPhillips, Dominion Energy, Inc., EOG Resources, Inc., Hologic Inc., Home Depot, Inc., Illinois Tool Works Inc., J. M. Smucker Company, JB Hunt Transport Services Inc., Kraft Heinz, Lowe\'s Companies Inc., Mastercard Incorporated, Middleby Corporation, Minerals Technologies Inc, ONEOK Inc., Oracle Corporation, Range Resources Corporation, RBC, Spectra Energy Corp., Tractor Supply Company, Umpqua Holding Corporation, Valmont Industries, Inc., Verizon Communications Inc., WhiteWave Foods Company, and Yum! Brands.'
    },
    {
      name: 'Domini',
      statement: 'For many years, Domini has incorporated concerns about deforestation into its investment decision-making and shareholder engagement work. Deforestation is a key contributor to climate change and a threat to biodiversity, indigenous peoples and local communities. We have submitted shareholder proposals and engaged in dialogue with a variety of corporations on these issues, including paper and pulp, soy, sugar, charcoal (for pig-iron production), beef and palm oil sourcing and related human rights impacts.  We have convinced a number of companies to adopt and improve policies, practices and public reporting on forestry impacts. We often work in collaboration with forestry NGOs and other concerned investors. Visit www.domini.com for more information.',
      filedAt: 'Avon Products, Concho Resources, Inc., International Paper Co., Kraft Foods, Kraft Heinz, Lowe\'s Companies, Mondelez International, PepsiCo, Procter & Gamble, R.R. Donnelley & Sons Company, and Southwestern Energy Co.'
    },
    {
      name: 'Calvert',
      statement: '',
      filedAt: 'AGL Resources Inc., Amazon.com Inc, AT&T, Inc., Casey\'s General Stores, Inc., CBRE Group, Inc, CenterPoint Energy, Inc., Cleco Corporation, Colgate-Palmolive, Colgate-Palmolive Co., Danaher Corp., Dillard\'s Inc., Dish Network Corporation, Dover Corp., Dr Pepper Snapple Group, Inc., Expedia Inc., FirstEnergy Corp., Genesee & Wyoming Inc, H.B. Fuller Company, HD Supply Holdings, Inc, Hertz Global Holdings, Inc., International Flavors & Fragrances Inc., J. C. Penney Company, Inc., JB Hunt Transport Services Inc., Kansas City Southern, Kroger, L Brands Inc, Marriott International, Inc., Nucor Corporation, PACCAR Inc., Pioneer Natural Resources Co., Polaris Industries, Public Storage, QEP Resources, Inc., Safeway Inc., Sears Holdings Corporation, Sensient Technologies, SM Energy Corporation, Smithfield Foods, Inc., Southwest Gas Corporation, Staples, Inc., TJX Companies, Inc., and Yum! Brands, Inc.'
    },
    {
      name: 'Boston Trust Walden Funds',
      statement: 'THIS STATEMENT PROVIDED BY WALDEN FUNDS: A core focus of Walden’s climate-related engagement is to encourage companies to adopt robust climate policies and science-based GHG goals, consistent with reports by the Intergovernmental Panel on Climate Change or IPCC. This translates to a reduction in GHG emissions of 55 percent globally by 2050 compared to 2010, the likely minimum decrease needed to avoid the most disastrous consequences of global warming. The destruction of tropical forests and peatlands in Indonesia and Malaysia to make room for palm oil production contributes significantly to climate change. As context, during the 26-day period beginning September 1, 2015, researchers from VU University in Amsterdam calculated that daily GHG emissions from fires in Indonesia to clear land for palm oil and pulp production surpassed those of the entire U.S. Walden has engaged companies in client portfolios that have exposure to the palm oil value chain, pressing for commitments to address not only the climate, but also biodiversity and human rights impacts of its development.',
      filedAt: 'Advance Auto Parts Inc., Cabot Oil & Gas Corporation, Comcast Corporation, ConocoPhillips, Costco Wholesale Corporation, Denbury Resources Inc., Emerson Electric, Hubbell Incorporated, Lincoln Electric Holdings, Mettler-Toledo International Inc., PNM Resources, Qualcomm Incorporated, and Stryker Corp.'
    },
    {
      name: 'Impax',
      statment: '',
      filedAt: 'Nucor Corporation.'
    }
  ],
  /*ignore jslint start*/
  formOptions: {
    market: [
        { name: 'All funds', value:'Show all funds' },
        { name: 'United States', value:'US' },
        // { name: 'Hong Kong', value:"HK" },
        // { name: 'United Kingdom', value:"UK" },
        // { name: 'Denmark', value:"DK" },
        // { name: 'France', value:"FR" },
        // { name: 'Germany', value:"DE" }
    ],
    type: [
        { name: 'All funds', value: 'All funds' },
        { name: 'Open-end funds', value: 'Open' },
        { name: 'Exchange-traded funds (ETFs)', value: 'ETF' },
        // { name: 'Common/Collective trusts', value: 'TSP' },
        { name: 'Variable annuities', value: 'VA' },
    ],
    diversified : [
        { name: 'All funds', value: false },
        { name: 'Diversified', value: 'false' },
        { name: 'Non-diversified', value: 'true' }
    ],
    sri : [
        { name: 'All funds', value: false },
        { name: 'Sustainability mandate', value: '1.0'},
        { name: 'US-SIF funds', value: '1.5'},
    ],
    fundUssif : [
        { name: 'All funds', value: false },
        { name: 'US-SIF funds', value: 1.5},
    ],
    targetDate : [
        { name: 'All funds', value: false },
        { name: 'Target date funds', value: '1.0'},
    ],
    fundPerformance : [
        { name: 'All funds', value: false },
        { name: 'Positive 1-year returns', value: 'trailing_return_y1' },
        { name: 'Positive 3-year returns', value: 'trailing_return_y3' },
        { name: 'Positive 5-year returns', value: 'trailing_return_y5' },
        { name: 'Positive 10-year returns', value: 'trailing_return_y10' },
        { name: 'Positive 15-year returns', value: 'trailing_return_y15' },
        { name: 'Positive 20-year returns', value: 'trailing_return_y20' },
    ],
    deiGrade : [
        { name: 'All funds', value: false },
        { name: 'Diversity disclosures grade A', value: 1 },
        { name: 'Diversity disclosures grade B or higher', value: 2 },
        { name: 'Diversity disclosures grade C or higher', value: 3 },
        { name: 'Diversity disclosures grade D or higher', value: 4 },
    ],
    rjiGrade : [
        { name: 'All funds', value: false },
        { name: 'Racial justice grade A', value: 1 },
        { name: 'Racial justice grade B or higher', value: 2 },
        { name: 'Racial justice grade C or higher', value: 3 },
        { name: 'Racial justice grade D or higher', value: 4 },
    ],
    hrcGrade : [
        { name: 'All funds', value: false },
        { name: 'LGBTQ+ equity grade A', value: 1 },
        { name: 'LGBTQ+ equity grade B or higher', value: 2 },
        { name: 'LGBTQ+ equity grade C or higher', value: 3 },
        { name: 'LGBTQ+ equity grade D or higher', value: 4 },
    ],
    fffGrade : [
        { name: 'All funds', value: false },
        { name: 'Fossil fuel grade A', value: 1 },
        { name: 'Fossil fuel grade B or higher', value: 2 },
        { name: 'Fossil fuel grade C or higher', value: 3 },
        { name: 'Fossil fuel grade D or higher', value: 4 },
    ],
    ffbGrade : [
        { name: 'All funds', value: false },
        { name: 'Fossil finance grade A', value: 1 },
        { name: 'Fossil finance grade B or higher', value: 2 },
        { name: 'Fossil finance grade C or higher', value: 3 },
        { name: 'Fossil finance grade D or higher', value: 4 },
    ],
    ffiGrade : [
        { name: 'All funds', value: false },
        { name: 'Fossil insurance grade A', value: 1 },
        { name: 'Fossil insurance grade B or higher', value: 2 },
        { name: 'Fossil insurance grade C or higher', value: 3 },
        { name: 'Fossil insurance grade D or higher', value: 4 },
    ],
    dffGrade : [
        { name: 'All funds', value: false },
        { name: 'Deforestation grade A', value: 1 },
        { name: 'Deforestation grade Engagement or higher', value: 1.5 },
        { name: 'Deforestation grade B or higher', value: 2 },
        { name: 'Deforestation grade C or higher', value: 3 },
        { name: 'Deforestation grade D or higher', value: 4 },
    ],
    gefGrade : [
        { name: 'All funds', value: false },
        { name: 'Gender equality grade A', value: 1 },
        { name: 'Gender equality grade B or higher', value: 2 },
        { name: 'Gender equality grade C or higher', value: 3 },
        { name: 'Gender equality grade D or higher', value: 4 },
    ],
    wffGrade : [
        { name: 'All funds', value: false },
        { name: 'Weapon grade A', value: 1 },
        { name: 'Weapon grade B or higher', value: 2 },
        { name: 'Weapon grade C or higher', value: 3 },
        { name: 'Weapon grade D or higher', value: 4 },
    ],
    gffGrade : [
        { name: 'All funds', value: false },
        { name: 'Civilian firearm grade A', value: 1 },
        { name: 'Civilian firearm grade B or higher', value: 2 },
        { name: 'Civilian firearm grade C or higher', value: 3 },
        { name: 'Civilian firearm grade D or higher', value: 4 },
    ],
    tffGrade : [
        { name: 'All funds', value: false },
        { name: 'Tobacco grade A', value: 1 },
        // { name: 'Tobacco grade Engagement or higher', value: 1.5 },
        { name: 'Tobacco grade B or higher', value: 2 },
        { name: 'Tobacco grade C or higher', value: 3 },
        { name: 'Tobacco grade D or higher', value: 4 },
    ],
    pffGrade : [
        { name: 'All funds', value: false },
        { name: 'Prison industrial complex grade A', value: 1 },
        { name: 'Prison industrial complex grade B or higher', value: 2 },
        { name: 'Prison industrial complex grade C or higher', value: 3 },
        { name: 'Prison industrial complex grade D or higher', value: 4 },
    ],
    clean : [
        { name: 'All funds', value: false },
        { name: 'A grade funds only', value: 'true' }
    ],
    currency: [],
    currencyAll: [
      { name: 'All funds' },
      { name: 'US Dollar' },
    ],
    currencyUS: [
    //
    ],
    currencyUK: [
    //
    ],
    currencyHK: [
    //
    ],
    currencyDK: [
    //
    ],
    currencyFR: [
    //
    ],
    currencyDE: [
    //
    ],
    fundGroup: [],
    fundGroupAll: [
      { name: 'All funds' },
      { name: 'Allocation' },
      { name: 'International Equity' },
      { name: 'Sector Equity' },
      { name: 'U.S. Equity' },
      // { name: 'U.S. Small/Mid Cap Equity' },
      // { name: 'U.S. Large Cap Equity' },
    ],
    fundGroupUS: [
    //
    ],
    fundGroupUK: [
    //
    ],
    fundGroupHK: [
    //
    ],
    fundGroupDK: [
      //
    ],
    fundGroupFR: [
    //
    ],
    fundGroupDE: [
    //
    ],
    fundCategory: [],
    fundCategoryAll: FundCategoryAll,
    fundCategoryUS: [
    //
    ],
    fundCategoryUK: [
    //
    ],
    fundCategoryHK: [
    //
    ],
    fundCategoryDK: [
      //
    ],
    fundCategoryFR: [
    //
    ],
    fundCategoryDE: [
    //
    ],
    fundFamily: [],
    fundFamilyAll: FundFamilyAll,
    fundFamilyUS : [
    //
    ],
    fundFamilyUK: [
    //
    ],
    fundFamilyHK: [
    //
    ],
    fundFamilyDK: [
    //
    ],
    fundFamilyFR: [
    //
    ],
    fundFamilyDE: [
    //
    ],
  },
  /*ignore jslint end*/


  app: {
    title: title,
    description: description,
    head: {
      defaultTitle: title,
      titleTemplate: '%s | ' + title,
      meta: [
        {name: 'description', content: description},
        {charset: 'utf-8'},
        // twitter
        {property: 'twitter:card', content: 'summary_large_image' },
        {property: 'twitter:site', content: '@asyousow' },
        {property: 'twitter:title', content: title },
        {property: 'twitter:description', content: description},
        {property: 'twitter:creator', content: '@asyousow'},
        {property: 'twitter:image', content: ''},
        // {property: 'twitter:image', content: 'http://www.asyousow.org/images/img-401k-ok.png'},

        // og
        {property: 'og:site_name', content: title },
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: domain},
        {property: 'og:locale', content: 'en_US'},
        {property: 'og:title', content: title },
        {property: 'og:description', content: description },
        {property: 'og:image', content: ''},
        // {property: 'og:image', content: 'http://www.asyousow.org/images/img-401k-ok.png'},
        // {property: 'og:image:width', content: '545'},
        // {property: 'og:image:height', content: '478'}

      ]
    }
  },
}
// inject the serverconfig if its on the browser
if(typeof window !== 'undefined') {
  config = Object.assign({},config,window.__serverConfig)
}
module.exports = config